import { Button, ButtonGroup, Divider, ModalBody, ModalFooter, Stack, Text, useDisclosure, useToast } from "@chakra-ui/react";
import { Form, Modal } from "components";
import { API } from "config";
import { useOrder } from "hooks";
import { useState } from "react";
import { Authenticate } from "screens";

export default function Status({ data, ...props }){

    const toast = useToast()
    const order = useOrder(data?.id)
    const [ loading, setLoading ] = useState(false)
    const [ status, setStatus ] = useState()
    const auth = useDisclosure()

    const handleSubmit = async () => {
        setLoading(true)

        try{
            await API.post(`/orders/${order.data?.id}`, { status, _method: 'put' })
            toast({ title: 'Status do pedido alterado!' })
            order.refetch()
            props?.onClose()
        }catch(err){
            toast({ title: 'Não foi possível alterar o status. Tente novamente.', description: err?.response?.data?.message, status: 'warning' })
        }

        setLoading(false)
    }

    const options = [
        { label: 'Em Análise', value: 12 },
        { label: 'Aprovado', value: 3 },
        { label: 'Em Montagem', value: 6 },
        { label: 'Cotação', value: 7 },
        { label: 'Fiscal', value: 11 },
        { label: 'Aguardando Transportadora', value: 8 },
        { label: 'Em Trânsito', value: 9 },
        { label: 'Aguardando Retirada', value: 11 },
        { label: 'Concluído', value: 2 }
    ]

    return(
    <>
    <Modal title="Alterar status do pedido" {...props}>
        <ModalBody>
            <Stack spacing={4}>
                <Text fontSize="sm">Você está prestes a alterar o status do pedido. Tenha em mente que altera o status diretamente pode atrapalhar os fluxos convencionais do sistema.</Text>

                <Divider />

                <Form.Select
                    label="Selecione o status:"
                    options={options}
                    onChange={e => setStatus(e.target.value)}
                />
            </Stack>
        </ModalBody>
        <ModalFooter>
            <ButtonGroup size="sm" isDisabled={order.isFetching || !!loading}>
                <Button colorScheme="orange" isLoading={loading} isDisabled={!status} onClick={auth.onOpen}>Alterar status</Button>
                <Button onClick={props?.onClose}>Fechar</Button>
            </ButtonGroup>
        </ModalFooter>
    </Modal>

    <Authenticate {...auth} onSuccess={handleSubmit} />
    </>
    )
}